export default {
  methods: {
    permissionHandler(key) {
      return this.$store.state.AppActiveUser.user.is_client
        ? this.$store.state.AppActiveUser.user.role
          ? this.$store.state.AppActiveUser.user.role.permissions.includes(key)
          : false
        : true;
    }
  }
};
